import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgHealthcareIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 33 32"
    fill="currentColor"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeWidth={0.289}
      d="M16.35 22.356a.794.794 0 0 0-.573.22.794.794 0 0 0-.221.574c0 .228.076.429.22.573a.794.794 0 0 0 .574.221h1.3a.794.794 0 0 0 .573-.22.794.794 0 0 0 .221-.574.794.794 0 0 0-.22-.573.794.794 0 0 0-.574-.221zm-6.5-5.2a.794.794 0 0 0-.573.22.794.794 0 0 0-.221.574c0 .228.076.429.22.573a.794.794 0 0 0 .574.221h1.3a.794.794 0 0 0 .573-.22.794.794 0 0 0 .221-.574.794.794 0 0 0-.22-.573.794.794 0 0 0-.574-.221zm7.8 0h-1.3a.794.794 0 0 0-.573.22.794.794 0 0 0-.221.574c0 .228.076.429.22.573a.794.794 0 0 0 .574.221h1.3a.794.794 0 0 0 .573-.22.794.794 0 0 0 .221-.574.794.794 0 0 0-.22-.573.794.794 0 0 0-.574-.221Zm-6.5 5.2h-1.3a.794.794 0 0 0-.573.22.794.794 0 0 0-.221.574c0 .228.076.429.22.573a.794.794 0 0 0 .574.221h1.3a.794.794 0 0 0 .573-.22.794.794 0 0 0 .221-.574.794.794 0 0 0-.22-.573.794.794 0 0 0-.574-.221Zm7.8-12.35h-1.156V8.85a.794.794 0 0 0-.22-.573.794.794 0 0 0-.574-.221.794.794 0 0 0-.573.22.794.794 0 0 0-.221.574v1.156H15.05a.794.794 0 0 0-.573.22.794.794 0 0 0-.221.574c0 .228.076.429.22.573a.794.794 0 0 0 .574.221h1.156v1.156c0 .228.076.429.22.573a.794.794 0 0 0 .574.221.794.794 0 0 0 .573-.22.794.794 0 0 0 .221-.574v-1.156h1.156a.794.794 0 0 0 .573-.22.794.794 0 0 0 .221-.574.794.794 0 0 0-.22-.573.794.794 0 0 0-.574-.221Zm10.4-.65h-4.406V3.65a.794.794 0 0 0-.22-.573.794.794 0 0 0-.574-.221H9.85a.794.794 0 0 0-.573.22.794.794 0 0 0-.221.574v5.706H4.65a.794.794 0 0 0-.573.22.794.794 0 0 0-.221.574v18.2c0 .228.076.429.22.573a.794.794 0 0 0 .574.221h24.7a.794.794 0 0 0 .573-.22.794.794 0 0 0 .221-.574v-18.2a.794.794 0 0 0-.22-.573.794.794 0 0 0-.574-.221Zm-23.906 18.2V10.944H9.85a.794.794 0 0 0 .573-.22.794.794 0 0 0 .221-.574V4.444h12.712v5.706c0 .228.076.429.22.573a.794.794 0 0 0 .574.221h4.406v16.612zm18.706-5.2h-1.3a.794.794 0 0 0-.573.22.794.794 0 0 0-.221.574c0 .228.076.429.22.573a.794.794 0 0 0 .574.221h1.3a.794.794 0 0 0 .573-.22.794.794 0 0 0 .221-.574.794.794 0 0 0-.22-.573.794.794 0 0 0-.574-.221Zm-1.3-5.2a.794.794 0 0 0-.573.22.794.794 0 0 0-.221.574c0 .228.076.429.22.573a.794.794 0 0 0 .574.221h1.3a.794.794 0 0 0 .573-.22.794.794 0 0 0 .221-.574.794.794 0 0 0-.22-.573.794.794 0 0 0-.574-.221z"
    />
  </svg>
);
export default SvgHealthcareIcon;
